import React from "react";
import { Helmet } from "react-helmet";
import Content from "../../layouts/content";
import { StyledLink, StyledContentContainer } from "./style";
import { Breadcrumbs } from "@mui/material";
import { useWiserTheme } from "../../hooks/useWiserTheme";

interface IProps {
  title: string;
  children: React.ReactNode;
  breadcrumbLinks?: { text: string; link: string }[];
  darkModeActive?: boolean;
}

const PageLayout: React.FC<IProps> = ({
  title,
  children,
  breadcrumbLinks = [],
  darkModeActive: darkModeActiveProp,
}) => {
  const { darkModeActive: contextDarkMode } = useWiserTheme();
  const darkModeActive = darkModeActiveProp ?? contextDarkMode;

  return (
    <>
      <Helmet>
        <title>Wiser ~ {title}</title>
      </Helmet>
      <Content>
        {breadcrumbLinks.length > 0 && (
          <Breadcrumbs aria-label="breadcrumb">
            <StyledLink href="/" $darkModeActive={darkModeActive}>
              Anasayfa
            </StyledLink>
            {breadcrumbLinks.map((link) => (
              <StyledLink
                key={`${link.link}-${link.text}`}
                href={link.link}
                $darkModeActive={darkModeActive}
              >
                {link.text}
              </StyledLink>
            ))}
          </Breadcrumbs>
        )}
        <StyledContentContainer darkModeActive={darkModeActive}>
          {children}
        </StyledContentContainer>
      </Content>
    </>
  );
};

export default PageLayout;
